import { Select } from 'antd';
import { ChevronDown } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

import { TAssetGroup, TCollection, TProductCategory } from '@components/types';

interface MobileControlsProps {
  filterByCategory?: boolean;
  categoryId?: null | number;
  categories?: (TProductCategory | TAssetGroup)[];
  handleCategoryChange?: (id: number) => void;
  sortingOptions?: { value: string; label: string }[];
  handleSortingChange?: (option: string) => void;
  filterByCollection?: boolean;
  collectionId?: null | number;
  handleCollectionChange?: (id: number) => void;
  collections?: TCollection[];
  isScroll?: boolean;
}

export default function MobileControls({
  filterByCategory = true,
  categoryId,
  categories,
  handleCategoryChange,
  sortingOptions,
  handleSortingChange,
  filterByCollection = false,
  collectionId,
  handleCollectionChange,
  collections,
  isScroll,
}: MobileControlsProps) {
  const [width, setWidth] = useState(0);
  const carouselRef = useRef<HTMLDivElement | null>(null);

  function onSortingChange(value: string) {
    handleSortingChange(value);
  }

  useEffect(() => {
    if (carouselRef.current) {
      setWidth(
        carouselRef.current?.scrollWidth - carouselRef.current.offsetWidth
      );
    }
  }, [categories, collections]);

  return (
      <div className="md:hidden flex flex-row gap-2 overflow-x-scroll no-scrollbar">
        {isScroll ? (
          <></>
        ) : (
          <Select
            size="middle"
            placeholder="Sort"
            options={sortingOptions}
            onChange={onSortingChange}
            defaultValue={sortingOptions[0]?.value}
            popupMatchSelectWidth={false}
            className="[&_.ant-select-selector]:!rounded-full [&_.ant-select-selector]:!border-neutral-200"
            suffixIcon={
              <ChevronDown className="w-3 h-3 text-neutral-500" />
            }
          />
        )}

        {filterByCategory &&
          categories?.map((category) => (
            <div key={category.id} className="flex-shrink-0">
              {isScroll ? (
                <button
                  type="button"
                  key={category.id}
                  onClick={() => handleCategoryChange(category.id)}
                  className={`px-3 md:h-10 h-8 w-full text-sm font-semibold flex justify-center items-center rounded-full border cursor-pointer transition-colors whitespace-nowrap ${
                    categoryId === category.id
                      ? 'border-business-500 text-business-500 bg-business-100'
                      : 'bg-white border-neutral-200/70 text-neutral-600 hover:border-business-500/40'
                  }`}
                >
                  <span className="px-1 w-max font-manrope">
                    {category.name}
                  </span>
                </button>
              ) : (
                <button
                  type="button"
                  key={category.id}
                  onClick={() => handleCategoryChange(category.id)}
                  className={`px-3 h-8 grid place-items-center rounded-full border cursor-pointer transition-colors whitespace-nowrap ${
                    categoryId === category.id
                      ? 'bg-business-500 border-business-500'
                      : 'bg-white border-neutral-200/70 hover:border-business-500/40'
                  }`}
                >
                  <span
                    className={`text-sm ${
                      categoryId === category.id
                        ? 'text-white'
                        : 'text-neutral-600'
                    } font-manrope font-semibold whitespace-nowrap`}
                  >
                    {category.name}
                  </span>
                </button>
              )}
            </div>
          ))}

        {filterByCollection &&
          collections?.map((collection) => (
            <button
              type="button"
              key={collection?.id}
              onClick={() => handleCollectionChange(collection?.id)}
              className={`flex-shrink-0 px-3 h-8 grid place-items-center rounded-full border cursor-pointer transition-colors whitespace-nowrap ${
                collectionId === collection?.id
                  ? 'bg-business-500 border-business-500'
                  : 'bg-white border-neutral-200/70 hover:border-business-500/40'
              }`}
            >
              <span
                className={`text-sm ${
                  collectionId === collection?.id
                    ? 'text-white'
                    : 'text-neutral-600'
                } font-manrope font-semibold capitalize whitespace-nowrap`}
              >
                {collection?.title}
              </span>
            </button>
          ))}
      </div>
  );
}
